var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicroMute({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5001 12.5334V6.66675C20.5001 4.45761 18.7092 2.66675 16.5001 2.66675C14.9299 2.66675 13.5711 3.57144 12.9164 4.88799M16.5001 25.3334V29.3334M16.5001 25.3334C11.3454 25.3334 7.16675 21.1547 7.16675 16.0001V13.3334M16.5001 25.3334C21.6547 25.3334 25.8334 21.1547 25.8334 16.0001V13.3334M11.1667 29.3334H21.8334M3.16675 2.66675L29.8334 29.3334M16.5001 20.0001C14.2909 20.0001 12.5001 18.2092 12.5001 16.0001V12.0001L19.3302 18.8268C18.6062 19.5517 17.6055 20.0001 16.5001 20.0001Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicroMute);
export default __webpack_public_path__ + "static/media/micro-mute.7e4ecf4bef9b34057d1e0f2c321bdf1f.svg";
export { ForwardRef as ReactComponent };